export default __webpack_public_path__ + "static/media/LP-L-RW.c8f31a6c.jpg";